import { request } from '@umijs/max';
import { AdminAuthAccount, LoginParams, LoginResultData } from '../AdminTypings';

export namespace AdminPassport {
  /**
   * @summary 登录
   * @secure
   */
  export const login = async (data: LoginParams, params: { [key: string]: any } = {}) => {
    return request<LoginResultData>(`/admin/passport/login`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 注销登录
   * @secure
   */
  export const logout = async (params: { [key: string]: any } = {}) => {
    return request<boolean>(`/admin/passport/logout`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取登录信息
   * @secure
   */
  export const auth = async (params: { [key: string]: any } = {}) => {
    return request<AdminAuthAccount>(`/admin/passport/auth`, {
      method: 'GET',
      ...params,
    });
  };
}

export default AdminPassport;

export const login = AdminPassport.login;
export const logout = AdminPassport.logout;
export const auth = AdminPassport.auth;
